import { get, post } from "../index";

export const getDiffForTimeline = (timelineId) =>
  get(`/diff/timeline/${timelineId}`);

export const getFullDiffForTimeline = (timelineId) =>
  get(`/diff/timeline/${timelineId}/full`);

export const getComponentChangesForTimeline = (timelineId, type) => {
  const qs = type ? `?type=${type}` : "";
  return get(`/diff/timeline/${timelineId}/components${qs}`);
};

export const getMaterialChangesForTimeline = (timelineId) =>
  get(`/diff/timeline/${timelineId}/materials`);

export const getDiffForExport = (projectId) =>
  get(`/diff/export/${projectId}`);

export const getDiffsForProject = (projectId, sourceType = null) => {
  const qs = sourceType ? `?sourceType=${sourceType}` : "";
  return get(`/diff/project/${projectId}${qs}`);
};

export const getDiffStatus = (timelineId) =>
  get(`/diff/status/timeline/${timelineId}`);

export const recalculateTimelineDiff = (timelineId) =>
  post(`/diff/timeline/${timelineId}/recalculate`, {});

export const getDiffDownloadUrl = (timelineId, fileType) =>
  get(`/diff/timeline/${timelineId}/download/${fileType}`);

// Company-wide aggregation — single call across all accessible projects.
// filters: { kind?: "model" | "est" | "all", projectIds?: string[], limit?: number }
export const getCompanyDiffs = (filters = {}) => {
  const p = new URLSearchParams();
  if (filters.kind) p.append("kind", filters.kind);
  if (filters.projectIds?.length) p.append("projectIds", filters.projectIds.join(","));
  if (filters.limit) p.append("limit", filters.limit);
  const q = p.toString();
  return get(`/diff/company${q ? `?${q}` : ""}`);
};
